import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { show as showModal } from 'redux-modal';
import Waypoint from 'react-waypoint';
import rootTemplateParts from 'ui/common/routes/root-parts';
import { socialLinkTypeIds, socialLinkTypes } from 'ui/common/social-links';
import ExternalLink from 'ui/common/external-link';
import EmsEmployeeProfile from 'ui/graphql/EmsEmployeeProfile/loadable';
// import EmsUserScore from './ems-user-score';
import MediaQuery from 'react-responsive';
import themeConfig from 'ui/theme/config';
import { push } from 'react-router-redux';
import { ensureScheme } from 'utils/url';
import Card from 'ui/common/card/Card';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'ui/common/dropdown';

import { updateCurrentProfileSection } from 'store/features/users/actions';
import { selectCurrentUserId, selectIsCurrentUserNoAccess } from 'store/features/auth/selectors';
import {
  selectIsFetchingUserByUsername,
  selectIsFetchingUserById,
  selectIsUserFetchedAtleastOnceByUsername,
  selectIsUserFetchedAtleastOnceById,
} from 'store/features/users/selectors';

import RequestedForDeletion from './requested-delete';
import ModalPureText from 'ui/components/modal-pure-text/loadable';

import UpdateBasicInfo, { MODAL_NAME as UPDATE_BASIC_INFO_MODAL } from 'ui/graphql/UpdateBasicInfo';
import LogoutAllDevices, {
  MODAL_NAME as LOGOUT_ALL_DEVICES_MODAL,
} from 'ui/graphql/LogoutAllDevices';
import UpdateSocialLinks, {
  MODAL_NAME as UPDATE_SOCIAL_LINKS_MODAL,
} from 'ui/graphql/UpdateSocialLinks';
import styles from './index.module.scss';
import * as messages from './messages';
import { defaultHeaderImages } from 'resources/page/profile';
import EmsChallengeFriend, {
  MODAL_NAME as CHALLENGE_FRIEND_MODAL,
} from 'ui/graphql/EmsChallengeFriend';

import TADA_IMG from './tada.svg';
import TEST_IMAGE from './test-image.svg';
import Avatar from 'ui/users/avatar';
import Icon from 'ui/common/icon';
import injectReducer from 'utils/injectReducer';
import { compose } from 'redux';
import Button from 'ui/common/button';
import EmsEmployeeProfileReducer from '../../../store/graphql/EmsEmployeeProfile/reducer';
import { selectMyInfo } from '../../../store/graphql/EmsEmployeeProfile/selectors';
import routeGenerators from '../../common/routes/generators';

export class Details extends Component {
  static propTypes = {
    id: PropTypes.string,
    username: PropTypes.string,
    user: PropTypes.object,
    claims: PropTypes.arrayOf(PropTypes.object),
  };

  constructor(props) {
    super(props);

    autoBind(this);

    this.state = {
      isBioModalOpen: false,
      isEditInfoOpen: false,
      activeTab: 'BLANKET_TEST',
    };

    this.defaultHeaderIndex = Math.round(Math.random() * (defaultHeaderImages.length - 1));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      nextProps.updateCurrentProfileSection(nextProps.id, nextProps.user ? 'bio' : '');
    }
  }

  componentWillUnmount() {
    this.props.updateCurrentProfileSection(this.props.id, '');
  }

  toggleEditInfoDropDown() {
    this.setState({
      isEditInfoOpen: !this.state.isEditInfoOpen,
    });
  }

  renderHelmet() {
    const { user, fetchingUser } = this.props;

    if (fetchingUser || !user) return null;

    const title = user.name;
    const description = user.bio;
    let image = user.imgUrl;
    if (image) ensureScheme(image);

    return (
      <Helmet>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="profile" />
        <meta property="og:title" content={title} />
        {description && <meta property="og:description" content={description} />}
        {image && <meta property="og:image" content={image} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        {description && <meta name="twitter:description" content={description} />}
        {image && <meta property="twitter:image" content={image} />}
      </Helmet>
    );
  }

  showBasicInfoModal() {
    this.props.showModal(UPDATE_BASIC_INFO_MODAL);
  }

  showSocialLinksModal() {
    this.props.showModal(UPDATE_SOCIAL_LINKS_MODAL);
  }

  showLogoutAllDevicesModal() {
    this.props.showModal(LOGOUT_ALL_DEVICES_MODAL);
  }

  renderSocialLinkItem(socialLink, index) {
    if (!socialLink) return null;

    const { intl: { formatMessage } } = this.props;
    const { type, url } = socialLink;

    if (!url) return null;

    const item = socialLinkTypes[type] || socialLinkTypes[socialLinkTypeIds.website];
    return (
      <li
        key={`${index}-${socialLinkTypeIds[type]}`}
        className={classnames('pr-3 py-2 d-inline-block')}
      >
        <ExternalLink href={url} openInNewTab>
          <Icon
            name={item.iconCustomClass || item.iconFaClass}
            tooltip={formatMessage(item.messages.name)}
            background
          />
        </ExternalLink>
      </li>
    );
  }

  renderSocialLinks() {
    const { user, fetchingUser } = this.props;
    if (!user || fetchingUser) return null;

    const items =
      user.socialLinks &&
      user.socialLinks.map((item, index) => this.renderSocialLinkItem(item, index)).filter(Boolean);

    if (!items || !items.length) return null;

    return <ul className={classnames('d-inline', styles.socialLinksList)}>{items}</ul>;
  }

  getUserName(name) {
    return name
      .toLowerCase()
      .split(' ')
      .join('_');
  }

  renderDesignationInfo() {
    const { myInfo } = this.props;
    // console.log('myInfo : ', myInfo);
    const companyName = myInfo && myInfo.company && myInfo.company.name;
    const role =
      myInfo && myInfo.workInfo && myInfo.workInfo.designation && myInfo.workInfo.designation.name;
    return (
      <div className={classnames('d-flex align-items-center')}>
        <div className={classnames(styles.companyInfo, 'd-inline')}>
          <h3 className={'m-0 px-3 py-1'}>{companyName || '-'}</h3>
        </div>
        <div className={classnames(styles.companyInfo, 'd-inline')}>
          <h3 className={'m-0 px-3 py-1'}>{role || '-'}</h3>
        </div>
      </div>
    );
  }

  renderHeaderMobile() {
    const { user, updateCurrentProfileSection } = this.props;

    return (
      <div className={styles.headBox}>
        <div className={'py-3 px-4'}>
          <Waypoint
            topOffset={'40%'}
            bottomOffset={'40%'}
            scrollableAncestor={window}
            onEnter={() => {
              updateCurrentProfileSection(user.id, 'bio');
            }}
          >
            <div>
              <Avatar
                user={user}
                size={80}
                className={classnames('text-center align-self-start mr-4')}
              />
            </div>
          </Waypoint>
        </div>
        <div className={'pb-3 px-4'}>
          <div className={classnames('media-body')}>
            <h1 className={classnames('my-0', styles.name)}>{user.name}</h1>
            {user.username && (
              <p
                className="pb-1 text-muted"
                style={{ fontSize: '14px', lineHeight: '20px' }}
              >{`@${this.getUserName(user.name)}`}</p>
            )}
            <UpdateBasicInfo />
            <UpdateSocialLinks />
            <LogoutAllDevices />
            {this.renderDesignationInfo()}
            {this.renderBioBody()}
            <div>
              <div>{this.renderSocialLinks()}</div>
              <div>{this.renderEditInfoButton()}</div>
            </div>
          </div>
        </div>
        <div className={classnames(styles.challengeBoxMobile, 'mx-0 px-0')}>
          {this.renderChallengeMobile()}
        </div>
      </div>
    );
  }

  renderHeader() {
    const { user, updateCurrentProfileSection } = this.props;

    return (
      <div className={styles.headBox}>
        <div className="row justify-content-between mr-0">
          <div className="col-7 d-flex flex-column justify-content-between py-4 px-5 mx-0">
            <Waypoint
              topOffset={'40%'}
              bottomOffset={'40%'}
              scrollableAncestor={window}
              onEnter={() => {
                updateCurrentProfileSection(user.id, 'bio');
              }}
            >
              <div className="media h-100">
                <div className="text-center mb-3">
                  <Avatar
                    user={user}
                    size={145}
                    className={classnames('text-center align-self-start mr-4')}
                  />
                </div>
                <div
                  className={classnames(
                    'media-body h-100 d-flex flex-column justify-content-between'
                  )}
                >
                  <div>
                    <h1 className={classnames('my-0', styles.name)}>{user.name}</h1>
                    {user.username && (
                      <p
                        className="pb-1 text-muted"
                        style={{ fontSize: '14px', lineHeight: '20px' }}
                      >{`@${this.getUserName(user.name)}`}</p>
                    )}
                    {this.renderDesignationInfo()}
                    <UpdateBasicInfo />
                    <UpdateSocialLinks />
                    <LogoutAllDevices />
                    <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.sm}>
                      {this.renderBioBody()}
                    </MediaQuery>
                  </div>
                  <div className={'d-flex align-items-center'}>
                    <div>{this.renderSocialLinks()}</div>
                    <div>{this.renderEditInfoButton()}</div>
                  </div>
                </div>
              </div>
            </Waypoint>
          </div>
          <div className={classnames(styles.challengeBox, 'col-5 text-center mx-0 px-0')}>
            {this.renderChallenge()}
          </div>
        </div>
      </div>
    );
  }

  renderChallenge() {
    const { hasSubmittedCurrentTest, currentTestPublicId } = this.props;
    return (
      <div className={'row h-100 py-4 px-4'}>
        <div className={'col-7 text-left d-flex flex-column justify-content-between'}>
          <div>
            <h1 className={'m-0 p-0'}>{!!hasSubmittedCurrentTest ? 'Nice work!' : 'Hey!'}</h1>
            {!!hasSubmittedCurrentTest ? (
              <p className={'mt-2'}>
                You have completed your weekly surveys. You can check your responses on your profile
                below.
                <br />
                Your next survey will be in the next week. We'll notify you of the same!
              </p>
            ) : (
              <p className={'mt-2'}>
                It seems that you have you haven't finished your pulse surveys this week. It
                shouldn't take more than 5 minutes!
              </p>
            )}
          </div>
          <div className={'d-flex align-items-center mb-1'}>
            {!hasSubmittedCurrentTest ? (
              <Button
                to={routeGenerators.ems.assessmentMagicLink({ publicId: currentTestPublicId })}
                color={'company-white'}
                // disabled={!!hasSubmittedCurrentTest}
                // onClick={() => this.props.showModal(CHALLENGE_FRIEND_MODAL, {})}
              >
                Let's Start
              </Button>
            ) : (
              <Button
                color={'company-white'}
                onClick={() => this.props.showModal(CHALLENGE_FRIEND_MODAL, {})}
              >
                Challenge a friend
              </Button>
            )}
          </div>
        </div>
        <div className={'col-5 mt-4'}>
          <img
            src={!!hasSubmittedCurrentTest ? TADA_IMG : TEST_IMAGE}
            alt={'tada'}
            className={'mx-auto'}
            width={'170px'}
          />
        </div>
      </div>
    );
  }

  renderChallengeMobile() {
    const { hasSubmittedCurrentTest, currentTestPublicId } = this.props;
    return (
      <div className={'h-100 py-4 px-4'}>
        <div className={'d-flex align-items-center'}>
          <img
            src={!!hasSubmittedCurrentTest ? TADA_IMG : TEST_IMAGE}
            alt={'tada'}
            width={'120px'}
          />
          <h1 className={'m-0 p-0 mb-2'}>{!!hasSubmittedCurrentTest ? 'Nice work!' : 'Hey!'}</h1>
        </div>
        <div className={'text-left'}>
          {!!hasSubmittedCurrentTest ? (
            <p>
              You have completed your weekly surveys. You can check your responses on your profile
              below.
              <br />
              Your next survey will be in the next week. We'll notify you of the same!
            </p>
          ) : (
            <p>
              It seems that you have you haven't finished your pulse surveys this week. It shouldn't
              take more than 5 minutes!
            </p>
          )}
        </div>
        <div className={'text-left mt-3'}>
          {!hasSubmittedCurrentTest ? (
            <Button
              to={routeGenerators.ems.assessmentMagicLink({ publicId: currentTestPublicId })}
              color={'company-white'}
              // disabled={!!hasSubmittedCurrentTest}
              // onClick={() => this.props.showModal(CHALLENGE_FRIEND_MODAL, {})}
            >
              Let's Start
            </Button>
          ) : (
            <Button
              color={'company-white'}
              onClick={() => this.props.showModal(CHALLENGE_FRIEND_MODAL, {})}
            >
              Challenge a friend
            </Button>
          )}
        </div>
      </div>
    );
  }

  // <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.sm - 1}>
  // {this.renderBioBody()}
  // </MediaQuery>

  renderEditInfoButton() {
    const { intl: { formatMessage } } = this.props;
    return (
      <div className="list-inline">
        <div className="list-inline-item">
          <Dropdown isOpen={this.state.isEditInfoOpen} toggle={() => this.toggleEditInfoDropDown()}>
            <DropdownToggle>
              <Button isReady={false}>{formatMessage(messages.labels.editInformation)}</Button>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => this.showBasicInfoModal()}>
                {formatMessage(messages.labels.editProfile)}
              </DropdownItem>

              <DropdownItem onClick={() => this.showSocialLinksModal()}>
                {formatMessage(messages.labels.editSocialLinks)}
              </DropdownItem>

              <DropdownItem onClick={() => this.showLogoutAllDevicesModal()}>
                {formatMessage(messages.labels.logoutAllDevices)}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    );
  }

  renderBioBody() {
    const { user, intl: { formatMessage } } = this.props;

    const { isBioModalOpen } = this.state;
    return (
      <div className={'mt-2'}>
        <p className={classnames('pt-2 pb-3')}>
          {`${(user.bio || '').substring(0, 120)}`}
          {(user.bio || '').length > 120 && '...'}
          {(user.bio || '').length > 120 && (
            <a
              className="cursor-pointer ml-2 text-black-50"
              onClick={() => this.setState({ isBioModalOpen: true })}
            >
              {formatMessage(messages.labels.readMore)}
            </a>
          )}
        </p>
        <ModalPureText
          closeFn={() => this.setState({ isBioModalOpen: false })}
          isOpen={isBioModalOpen}
        >
          <p className="mb-5 text-break-word text-whitespace-pre-wrap text-center">{user.bio}</p>
        </ModalPureText>
      </div>
    );
  }

  renderUserHeatmap() {
    return (
      <Card borderless className={'px-5 py-4'}>
        <div>
          <h1>Heatmap</h1>
        </div>
      </Card>
    );
  }

  render() {
    const { username, id, isCurrentUser } = this.props;

    if (!username && !id) return null;
    return (
      <div className={classnames(styles.emsProfile)}>
        {this.renderHelmet()}
        {isCurrentUser && <RequestedForDeletion />}
        <div>
          <div className={styles.emsHeader}>
            <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.lg - 1}>
              {this.renderHeaderMobile()}
            </MediaQuery>
            <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.lg}>
              {this.renderHeader()}
            </MediaQuery>
          </div>
          <div className={classnames('mt-4', styles.emsData)}>
            <EmsEmployeeProfile />
          </div>
        </div>
        <EmsChallengeFriend />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const myInfo = selectMyInfo(state);
  const { user } = ownProps;
  const currentUserId = selectCurrentUserId(state);
  let usernameFromRoute =
    ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.username;
  if (usernameFromRoute) usernameFromRoute = usernameFromRoute.toLowerCase();
  const username = rootTemplateParts.indexOf(usernameFromRoute) >= 0 ? null : usernameFromRoute;
  const id = user.id;
  const isEmsUser = user && user.type === 'EMS_USER';
  const isCurrentUser = currentUserId ? id === currentUserId : false;
  const canManage = isCurrentUser && !selectIsCurrentUserNoAccess(state);
  const fetchingUser = username
    ? selectIsFetchingUserByUsername(state, { username })
    : selectIsFetchingUserById(state, { id });

  const currentTest =
    myInfo &&
    Array.isArray(myInfo.employeeTests) &&
    myInfo.employeeTests.length > 0 &&
    myInfo.employeeTests[0];
  const currentTestPublicId =
    currentTest &&
    currentTest.emsEmployeeTestItem &&
    currentTest.emsEmployeeTestItem.emsTest &&
    currentTest.emsEmployeeTestItem.emsTest.assessmentMagicLink &&
    currentTest.emsEmployeeTestItem.emsTest.assessmentMagicLink.publicId;
  const testRuns =
    currentTest &&
    currentTest.emsEmployeeTestItem &&
    Array.isArray(currentTest.emsEmployeeTestItem.emsTestRuns) &&
    currentTest.emsEmployeeTestItem.emsTestRuns;
  const currentTestRun =
    Array.isArray(testRuns) && testRuns.length > 0 && testRuns[testRuns.length - 1];
  const hasSubmittedCurrentTest = currentTestRun && currentTestRun.hasUserSubmitted;

  return {
    id,
    myInfo,
    username,
    currentUserId,
    isCurrentUser,
    canManage,
    fetchingUser,
    user,
    isEmsUser,
    hasSubmittedCurrentTest,
    currentTestPublicId,
    fetchedUserAtleastOnce: username
      ? selectIsUserFetchedAtleastOnceByUsername(state, { username })
      : selectIsUserFetchedAtleastOnceById(state, { id }),
  };
}

const mapDispatchToProps = {
  showModal,
  updateCurrentProfileSection,
  push,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: 'EmsEmployeeProfile',
  reducer: EmsEmployeeProfileReducer,
});

export default compose(withReducer, withConnect)(injectIntl(Details));
